import React from "react";
import { DateOffersProps } from "./types";
import styles from "./date-offers.module.css";

const DateOffer = ({ children, styleClass }: DateOffersProps) => {
  return (
    <div aria-label='date-offer-content' className={styleClass}>
      <div className={styles.dateBox}>
        <div className={styles.percentage}>
          <span className='icon-percentage-fill-stroke'></span>
        </div>
        <p className={styles.dateText}>{children}</p>
      </div>
    </div>);

};

export default DateOffer;